import logger from '../../utils/logger';
import React from 'react';
import { Database, GitBranch } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SearchResults = ({ results, onClose }) => {
  const navigate = useNavigate();

  const getIcon = (type) => {
    switch (type) {
      case 'connection':
        return <Database size={16} />;
      case 'pipeline':
        return <GitBranch size={16} />;
      default:
        return null;
    }
  };

  const handleResultClick = (result) => {
    navigate(result.link);
    onClose();
  };

  if (results.length === 0) {
    return (
      <div className="absolute top-full left-0 right-0 mt-1 bg-white/70 dark:bg-gray-900/70 backdrop-blur-2xl rounded-xl border border-white/40 dark:border-white/[0.08] py-2 px-3">
        <div className="text-gray-500 dark:text-gray-400 text-sm">No results found</div>
      </div>
    );
  }

  return (
    <div className="absolute top-full left-0 right-0 mt-1 bg-white/70 dark:bg-gray-900/70 backdrop-blur-2xl rounded-xl border border-white/40 dark:border-white/[0.08] max-h-96 overflow-y-auto">
      {results.map((result, index) => (
        <div
          key={`${result.type}-${result.id}`}
          className={`flex items-start p-3 hover:bg-gray-50 cursor-pointer ${
            index !== results.length - 1 ? 'border-b border-gray-100' : ''
          }`}
          onClick={() => handleResultClick(result)}
        >
          <div className="flex-shrink-0 text-gray-500 mr-3">
            {getIcon(result.type)}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline">
              <h4 className="text-sm font-medium text-gray-900 truncate">
                {result.title}
              </h4>
              <span className="ml-2 text-xs text-gray-500 capitalize">
                {result.type}
              </span>
            </div>
            {result.description && (
              <p className="mt-1 text-xs text-gray-500 line-clamp-2">
                {result.description}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SearchResults; 